<div style="position:relative;">
  <div class="row-no-margin section-header-container">
    <div class="col-md-10 clear-padding">
      <span class="section-header">RMAs</span>
      <div class="row-no-margin">
        <div class="col-md-3 clear-padding">
          <mat-form-field appearance="fill">
            <mat-label>Sort by:</mat-label>
            <mat-select id="rmaSort" (selectionChange)="RMASort_Change($event)" [(value)]="RMASortValue">
              <mat-option value="received">
                Received
              </mat-option>
              <mat-option value="status">
                Status
              </mat-option>
              <mat-option value="shiptoname">
                Ship to Name
              </mat-option>
              <mat-option value="issuedate">
                Issue Date
              </mat-option>
              <mat-option value="evaldate">
                Eval Date
              </mat-option>
              <mat-option value="needsresponse">
                Needs Response
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-6 clear-padding">
          <mat-form-field *ngIf="CurUser.IsTolomaticUser" appearance="fill">
            <mat-label>Distributor:</mat-label>
            <mat-select id="orderDistributor" (selectionChange)="Dist_Change($event)" [value]="CurrentDist">
              <mat-option *ngFor="let dist of DistList" [value]="dist.CompanyId">
                {{dist.Company}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <!--
        <div class="col-md-3">
          <button [matMenuTriggerFor]="FilterMenu" class="blue">FILTERS</button>
          <mat-menu (click)="$event.stopPropagation()" #FilterMenu="matMenu">
            <div >
              <div (click)="$event.stopPropagation()" class="row-no-margin">
                <mat-form-field appearance="fill" style="width:100%;">
                  <mat-label>RMA Number</mat-label>
                  <input matInput (click)="$event.stopPropagation()" [(ngModel)]="RMANumber_Filter.Value" />
                </mat-form-field>
              </div>
              <div (click)="$event.stopPropagation()" class="row-no-margin">
                
                <mat-form-field appearance="fill" style="width:100%;">
                  <mat-label>Repair Order</mat-label>
                  <input matInput (click)="$event.stopPropagation()" [(ngModel)]="RepairOrder_Filter.Value" />
                </mat-form-field>
              </div>
              <div (click)="$event.stopPropagation()" class="row-no-margin">
                
                <mat-form-field appearance="fill" style="width:100%;">
                  <mat-label>Original Order</mat-label>
                  <input matInput (click)="$event.stopPropagation()" [(ngModel)]="OriginalOrder_Filter.Value" />
                </mat-form-field>
              </div>
              
              <div (click)="$event.stopPropagation()" class="row-no-margin">
                <mat-form-field appearance="fill" style="width:100%;">
                  <mat-label>Issue Date Range</mat-label>
                  <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate (click)="$event.stopPropagation()" (dateChange)="SetStartDateFilterValue($event)" [(value)]="RMADateMin_Filter.Value" />
                    <input matEndDate (click)="$event.stopPropagation()" (dateChange)="SetEndDateFilterValue($event)" [max]="Max_EndDate" [(value)]="RMADateMax_Filter.Value" />
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
              </div>
              
              <div (click)="$event.stopPropagation()" class="row-no-margin">
                <mat-form-field appearance="fill" style="width:100%;">
                  <mat-label>PO Number</mat-label>
                  <input matInput (click)="$event.stopPropagation()" [(ngModel)]="PONumber_Filter.Value" />
                </mat-form-field>
              </div>
              <div (click)="$event.stopPropagation()" class="row-no-margin">
                
                <mat-form-field appearance="fill" style="width:100%;">
                  <mat-label>Ship To</mat-label>
                  <input matInput (click)="$event.stopPropagation()" [(ngModel)]="ShipTo_Filter.Value" />
                </mat-form-field>
              </div>
              <div (click)="$event.stopPropagation()" style="position:relative;padding-bottom:30px;">
                <button id="resetSearchFilters" class="blue" style="left:10px;position:absolute;" (click)="ResetFilters()">Reset</button>
                <button id="submitSearch" class="blue" style="right:10px;position:absolute;" (click)="SubmitFilters()">Done</button>
              </div>
            </div>
          </mat-menu>
        </div>-->
      </div>
      <div class="row-no-margin">
        <div class="col-md-2 clear-padding">
          <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
            <mat-label>Search by:</mat-label>
            <input matInput (click)="$event.stopPropagation()" placeholder="RMA Number" [(ngModel)]="RMANumber_Filter.Value" />
          </mat-form-field>
        </div>
        <div class="col-md-2 lr-p-15">
          <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
            <mat-label>Search by:</mat-label>
            <input matInput (click)="$event.stopPropagation()" placeholder="Repair Order" [(ngModel)]="RepairOrder_Filter.Value" />
          </mat-form-field>
        </div>
        <div class="col-md-2 clear-padding">
          <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
            <mat-label>Search by:</mat-label>
            <input matInput (click)="$event.stopPropagation()" placeholder="Original Order" [(ngModel)]="OriginalOrder_Filter.Value" />
          </mat-form-field>
        </div>
        </div>
      <div class="row-no-margin">
        <div class="col-md-3 clear-padding">
          <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
            <mat-label>Issue Date Range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate (click)="$event.stopPropagation()" placeholder="MM/DD/YYYY" (dateChange)="SetStartDateFilterValue($event)" [(value)]="RMADateMin_Filter.Value" />
              <input matEndDate (click)="$event.stopPropagation()" placeholder="MM/DD/YYYY" (dateChange)="SetEndDateFilterValue($event)" [max]="Max_EndDate" [(value)]="RMADateMax_Filter.Value" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="col-md-2 lr-p-15">
          <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
            <mat-label>Search by:</mat-label>
            <input matInput (click)="$event.stopPropagation()" placeholder="PO Number" [(ngModel)]="PONumber_Filter.Value" />
          </mat-form-field>
        </div>
        <div class="col-md-2 clear-padding">
          <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
            <mat-label>Search by:</mat-label>
            <input matInput (click)="$event.stopPropagation()" placeholder="Ship To" [(ngModel)]="ShipTo_Filter.Value" />
          </mat-form-field>
        </div>
        <div class="col-md-2 lr-p-15">

          <button id="submitSearch" class="blue" style="margin-top:10px;" (click)="SubmitFilters()">Search</button>
          <button id="resetSearchFilters" class="blue" style="margin-top:10px;margin-left:10px;" (click)="ResetFilters()">Reset</button>
        </div>
      </div>
    </div>
  </div>
  <div>
    <table style="width:100%;">
      <tr>
        <th>RMA Number</th>
        <th style="text-align:center;">Issue Date</th>
        <ng-container *ngIf="CurrentDist == '00000000-0000-0000-0000-000000000000'">
          <th style="text-align:center;">Distributor</th>
        </ng-container>
        <th style="text-align:center;">Ship to Name</th>
        <th style="text-align:center;">Customer PO</th>
        <th style="text-align:center;">Status</th>
        <th style="text-align:center;">Actions</th>
      </tr>
      <ng-container *ngFor="let rma of RMAList">
        <tr>
          <td>
            <button mat-icon-button aria-label="expand row" (click)="(rma.Expanded = !rma.Expanded); LoadDetails(rma); $event.stopPropagation()">
              <mat-icon *ngIf="!rma.Expanded" class="blue-color">keyboard_arrow_down</mat-icon>
              <mat-icon *ngIf="rma.Expanded" class="blue-color">keyboard_arrow_up</mat-icon>
            </button>
            {{rma.RMANumber}}
          </td>
          <td style="text-align:center;">
            {{rma.ReceiptDate  | date:'M/d/y'}}
          </td>
          <ng-container *ngIf="CurrentDist == '00000000-0000-0000-0000-000000000000'">
            <td>{{rma.DistributorName}}</td>
          </ng-container>
          <td [matTooltip]="rma.ShipToName" style="text-align:center;">
            {{rma.ShortShipTo}}
          </td>
          <td style="text-align:center;">
            {{rma.PONumber}}
          </td>
          <td style="text-align:center;">
            {{rma.RMAStatus}}
          </td>
          <td style="text-align:center;">
            <ng-container *ngIf="rma.RMAVerificationPath.length > 0">
              <span (click)="ViewRMAVerification(rma)" class="clickable blue-color"><fa-icon [icon]="faEye" class="clickable blue-color"></fa-icon>&nbsp;View Verification</span>
            </ng-container>
            <!--<app-toggle [initial]="rma.Following" [idForControl]="rma.RMANumber" [trueText]="" [falseText]="" (changed)="FollowOrder($event,rma.RMANumber)"></app-toggle>-->
          </td>
        </tr>
        <!--Expanded content column-->
        <ng-container *ngIf="rma.Expanded">
          <tr>
            <td colspan="7">
              <table class="sub-table" style="width:100%;">
                <tr>
                  <th></th>
                  <!--<th>Item</th>-->
                  <th>Description</th>
                  <th style="text-align:center;">Qty</th>
                  <th style="text-align:center;">Status</th>
                  <th style="text-align:center;">Eval Code</th>
                  <th style="text-align:center;">Repair Order</th>
                  <!--<th style="text-align:center;">Reason</th>-->
                  <th style="text-align:center;">Ship Date</th>
                  <th style="text-align:center;">Follow</th>
                  <th></th>
                </tr>
                <ng-container *ngFor="let RMAItem of rma.RMAItems | sort:'RMALine'">
                  <tr>
                    <td style="text-align:center;">
                      {{RMAItem.RMALine}}
                    </td>
                    <!--<td>
    {{RMAItem.Item}}
  </td>-->
                    <td>
                      <span [matTooltip]="RMAItem.Description">
                        {{RMAItem.ShortDesc}}
                      </span>
                    </td>
                    <td style="text-align:center;">
                      {{RMAItem.Quantity}}
                    </td>
                    <td style="text-align:center;">
                      <span class="clickable blue-color" (click)="OpenRMAItem(rma, RMAItem)">{{GetRMAItemStatusText(RMAItem)}}</span>
                    </td>
                    <td style="text-align:center;">
                      {{RMAItem.EvalDesc}}
                    </td>
                    <td style="text-align:center;">
                      {{RMAItem.RepairOrder}}
                    </td>
                    <!--<td style="display:inline-block;height:40px;line-height:2.5;width:200px;overflow:hidden; white-space:nowrap;text-overflow:ellipsis;">
                      <span [matTooltip]="RMAItem.Reason">
                        {{RMAItem.ShortReason}}
                      </span>
                    </td>-->
                  <td style="text-align:center;">
                    <ng-container *ngIf="RMAItem.Shipments.length == 1">
                      {{RMAItem.ShipDate | date:'M/d/y'}}
                    </ng-container>
                    <ng-container *ngIf="RMAItem.Shipments.length > 1">
                      Multiple
                    </ng-container>
                  </td>
                    <td style="text-align:center;">
                      <app-toggle [initial]="RMAItem.Followed" [idForControl]="RMAItem.RMAItemRowPointer" [trueText]="" [falseText]="" (changed)="FollowOrder($event,RMAItem.RMAItemRowPointer)"></app-toggle>
                    </td>
                    <td>
                      <ng-container *ngIf="RMAItem.EvalCode && RMAItem.Disp == '' && RMAItem.Status != 'Complete'">
                        <span (click)="RespondToRMAItem(rma,RMAItem)" class="clickable blue-color"><fa-icon [icon]="faShare" class="clickable blue-color"></fa-icon>&nbsp;Respond</span>
                      </ng-container>
                    </td>
                  </tr>
                </ng-container>
              </table>
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </table>
    <mat-paginator [length]="ItemCount" [pageSize]="PageSize" [pageSizeOptions]="PageSizeOptions" (page)="PageEvent($event)">
    </mat-paginator>
  </div>
  <div #spinnerModal id="spinnerModal" [hidden]="hideLoadingModal" style="width:100%;height:inherit;float:left;position:absolute;z-index:10000;display:block;left:0;top:0px;bottom:0px; background-color:#AAAAAA;opacity:0.4;">
    <div style="position: absolute; top: 45%; left: 45%;">
      <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
  </div>
</div>
<app-modal hidden="true"></app-modal>
